<template>
  <div v-if="loading">
    <div class="pt-4 pb-12 flex gap-8 justify-center overflow-hidden">
      <SkeletonLoader class="shrink-0 w-full sm:basis-1/2 xl:basis-1/3 aspect-image" />
      <SkeletonLoader class="hidden sm:block shrink-0 basis-1/2 xl:basis-1/3 aspect-image" />
      <SkeletonLoader class="hidden xl:block shrink-0 basis-1/3 aspect-image" />
    </div>
  </div>
  <Splide
    v-else-if="varietyPacks?.length"
    :options="options"
    :has-track="false"
    aria-label="Product Gallery"
    class="pt-4 pb-12"
  >
    <SplideTrack>
      <div
        v-for="pack in filteredVarietyPacks"
        :key="pack.title"
        class="splide__slide flex-center flex-col"
      >
        <ResponsiveImage
          v-if="pack.featuredImage"
          :image="pack.featuredImage"
          :alt="pack.title"
          :width="480"
          loading="eager"
          class="scale-105 sm:scale-100"
        />
        <a
          :aria-label="`Fill box with ${pack.title}`"
          class="button +large +green text-xl min-w-[200px]"
          data-gtm-action="variety pack slider button click"
          :data-gtm-label="pack.title"
          :href="`/products/custom-bundle?curated=${parameterize(pack.title)}&confirmation=modal`"
        >
          <span>Add {{ pack.title }}</span>
        </a>
      </div>
    </SplideTrack>
    <!-- <div class="splide__fade_cover" style="--fade-to-color: #fff;"></div> -->
  </Splide>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useVarietyPacksStore } from '@/stores'
import { parameterize } from '@/utils'
import { Splide, SplideTrack, type Options } from '@splidejs/vue-splide'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'
import SkeletonLoader from '@/components/shared/v2/skeleton-loader.vue'

const packsStore = useVarietyPacksStore()
const { varietyPacks, loading } = storeToRefs(packsStore)
const filteredVarietyPacks = computed(() => varietyPacks.value?.filter(pack => pack.featuredImage))

const options: Options = {
  perPage: 1,
  perMove: 1,
  gap: '4rem',
  type: 'loop',
  rewind: true,
  arrows: true,
  mediaQuery: 'min',
  breakpoints: {
    640: { perPage: 2, padding: '2rem' },
    1280: { perPage: 3, focus: 'center' }
  }
}

onMounted(packsStore.useVarietyPacks)
</script>
